import _ from "lodash";
import axios from "axios";

import { sisi_api_url } from "../api";

export const searchRequestTransfers = async ({ params }) => {
  try {
    const response = await axios.get(`${sisi_api_url}/transferengine/search`, {
      params,
    });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const searchRequestTransfersPOST = async ({ payload, onError }) => {
  try {
    const response = await axios.post(`${sisi_api_url}/transferengine/search`, payload);
    return _.get(response, "data", {});
  } catch (error) {
    onError();
    console.error(error);
  }
  return null;
};

export const pollTransfersSearch = async ({ session_id, onError }) => {
  try {
    const response = await axios.get(`${sisi_api_url}/transferengine/search/poll`, {
      params: { session_id },
    });
    return _.get(response, "data", {});
  } catch (error) {
    return onError(error);
  }
};

export const fetchSavedTransferSearchResults = async ({ search_session_id }) => {
  try {
    const response = await axios.get(`${sisi_api_url}/transferengine/search/${search_session_id}`);

    return response.data;
  } catch {
    return null;
  }
};

export const transferPreBook = async ({ data }) => {
  try {
    const response = await axios.post(`${sisi_api_url}/transferengine/pre-book/`, { ...data });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const createTransferBooking = async ({ payload }) => {
  try {
    const response = await axios.post(`${sisi_api_url}/transferengine/book/`, payload);
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};
